@if (brandingService.darkModeEnabled && (isLoggedIn || environment.defaultTheme === 'dark') && isZACView) {
  <link
    href="/assets/styles/dark.css"
    rel="stylesheet"
    type="text/css"
    />
}
@if (brandingService.darkModeEnabled && (isLoggedIn || environment.defaultTheme === 'dark')) {
  <link
    href="/assets/styles/darkmode.css"
    rel="stylesheet"
    type="text/css"
    />
}
@if (brandingService.darkModeStyleSheetLink && brandingService.darkModeEnabled) {
  <link
    [href]="brandingService.darkModeStyleSheetLink"
    rel="stylesheet"
    type="text/css"
    />
}
@if (brandingService.lightModeStyleSheetLink && !brandingService.darkModeEnabled) {
  <link
    [href]="brandingService.lightModeStyleSheetLink"
    rel="stylesheet"
    type="text/css"
    />
}
<div class="app-container" [ngClass]="{ loggedIn: isLoggedIn && !pageIsUnauthed, processActive: processActive, 'appLoaderActive': showAppLoader }">
  @if (isLoggedIn && !pageIsUnauthed) {
    <netfoundry-ui-side-bar [hide]="hideSideBar" [isCloudZiti]="isZACView"></netfoundry-ui-side-bar>
  }
  @if (isLoggedIn && !hideSideBar) {
    <netfoundry-ui-app-switcher (mouseenter)="handleMouseOver($event)"> </netfoundry-ui-app-switcher>
  }
  <main
    (mouseenter)="close()"
        [ngClass]="{
            zacView: isZACView,
            mopView: !isZACView,
            open: isNavOpen,
            shaded: isShaded,
            formShaded: isFormShaded,
            experimental: featureService.experimentalFeatures,
            newNav: true,
            noPad: !isLoggedIn || noPadding && !pageIsUnauthed,
            fullScreen: hideSideBar,
            darkmode: brandingService.darkModeEnabled && isLoggedIn,
            cardWarning:
                isLoggedIn && !billingEnabledService.hideCardWarning && billingEnabledService.isFourteenDayTrial,
            conflictPage: isConflictPage
        }"
    >
    <app-banner-message
      [isLoggedIn]="isLoggedIn"
      [message]="bannerMessage"
      [isVisible]="showBanner"
      [showSupportLink]="showSupportLink"
      [buttonText]="bannerButtonText"
      (buttonClicked)="bannerButtonClicked()"
      [showSpinner]="showBannerSpinner"
      (closeClicked)="bannerClosed()"
    ></app-banner-message>

    <app-banner-message
      [ngClass]="{one: !showBanner, two: showBanner }"
      id="ProcessBanner"
      [isLoggedIn]="isLoggedIn"
      [message]="processBannerMessage"
      [isVisible]="showProcessBanner"
      [showSupportLink]="true"
      [buttonText]="'Click here to view more details'"
      (buttonClicked)="processBannerButtonClicked()"
      (closeClicked)="processBannerClosed()"
    ></app-banner-message>

    <!-- banner message for ziti connection error -->
    <app-banner-message
      [ngClass]="{one: !showBanner && !showProcessBanner, two: ((showBanner || showProcessBanner) && !(showBanner && showProcessBanner)), three: showBanner && showProcessBanner}"
      id="ZitiBanner"
      [isLoggedIn]="isLoggedIn"
      [message]="bannerMessageZiti"
      [isVisible]="showBannerZiti"
      (closeClicked)="zitiBannerClosed()"
    ></app-banner-message>
    @if (isLoggedIn && !billingEnabledService.hideCardWarning && billingEnabledService.isFourteenDayTrial && !pageIsUnauthed) {
      <div
        class="creditCardWarningContainer"
        >
        <app-credit-card-warning (close)="closeWarning()" class="creditCardWarning"></app-credit-card-warning>
      </div>
    }

    @if (isLoggedIn && isHeader && !pageIsUnauthed) {
      <app-list-header
        [actionTitle]="actionTitle"
        [breadcrumb]="breadcrumb"
        [class.modern-billing-header]="tabs.includes('billing-management')"
        [hasAzureSubscription]="hasAzureSubscription"
        [hideSubscriptionsTab]="true"
        [network]="currentNetwork"
        [organization]="currentOrg"
        [resourceType]="resourceType"
        [shortBreadCrumbs]="shortBreadCrumbs"
        [tabs]="tabs"
        [title]="subtitle"
        [url]="url"
      ></app-list-header>
    }
    @if (isFilterable && isLoggedIn && showLegacySearch) {
      <app-side-filter
        [isTimeSearchAvailable]="isTimeSearchAvailable"
        [isNotDialLogs]="isNotDialLogs"
      ></app-side-filter>
    }
    <router-outlet></router-outlet>
    @if (isZACView && zitiControllerService.loadingZitiController) {
      <div class="ziti-loading-mask"></div>
    }
  </main>
  @if (featureService.zitiOverlayEnabled && (zitiWasmService.metricsPanelOpen$ | async)) {
    <aside class="ziti-metrics-aside">
      <lib-ziti-metrics-panel></lib-ziti-metrics-panel>
    </aside>
  }
  <app-dial-logs-timeline-drawer></app-dial-logs-timeline-drawer>
  <app-alert-detail-drawer-host></app-alert-detail-drawer-host>
</div>
<app-recent-alerts [currentNetwork]="currentNetwork"></app-recent-alerts>
<!-- Floating AI assistant chat. Hides itself until a network resolves and the
     assistant service reports the assistant on for it. -->
@if (isLoggedIn && !pageIsUnauthed) {
  <app-assistant-chat></app-assistant-chat>
}
<netfoundry-ui-overlay></netfoundry-ui-overlay>
<lib-growler></lib-growler>
<app-loading-indicator id="AppLoader" [isLoading]="appLoading && login.isLoggedIn"></app-loading-indicator>
